export const actionOptions = {
  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  "all": [
    {
      icon: 'toggle-on',
      title: 'Activate Selected Organizations',
      cls: "bulk-activate-organization",
      disabled:true
    },
    {
      icon: 'toggle-off',
      title: 'Deactivate Selected Organizations',
      cls: "bulk-deactivate-organization",
      disabled:true
    }
  ],
  "actions": [
    {
      title: "Edit",
      cls: "edit-organization",
      icon: "pencil",
      disabled:true
    },
    {
      title: "Activate/Deactivate",
      cls: "deactivate-organization",
      icon: "toggle-off",
      disabled:true
    }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/addressBook/filter/organizationActionOptions.js